// client/src/services/paymentReportService.js
import api from './api';

const paymentReportService = {
  getTransactionsWithPaidItems: async () => {
    const response = await api.get('/payment-reports/transactions-with-paid-items');
    return response.data;
  },
  
  generatePaymentReport: async (transactionId, reportType = 'detailed') => {
    try {
      const response = await api.get(`/payment-reports/${transactionId}?reportType=${reportType}`, {
        responseType: 'blob'
      });
      
      const blob = new Blob([response.data], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', `payment_report_${transactionId}_${reportType}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      return true;
    } catch (error) {
      console.error('Download error:', error);
      throw error;
    }
  },
  
  printReport: async (transactionId, reportType = 'detailed') => {
    try {
      const response = await api.get(`/payment-reports/${transactionId}?reportType=${reportType}&print=true`);
      return response.data;
    } catch (error) {
      console.error('Print error:', error);
      throw error;
    }
  }
};

export default paymentReportService;